import {toast} from "react-toastify";
import {Trads} from "./TradsErrorPages";

export const displayToastErrorFromResponse = (response, defaultMessage) => {
    console.trace();
    let errorMessage;
    if (Trads[response?.data?.message]) {
        const lang = localStorage.getItem('lang') || 'FR';
        errorMessage = Trads[response.data.message][lang];
    } else {
        errorMessage = defaultMessage || 'Data loading error';
    }
    toast.error(errorMessage);
}